import cloneDateTime from './cloneDateTime';
import getFirstDayOfWeek from './getFirstDayOfWeek';

function getBlankDaysBeforeFirstDay(firstDayOfMonth, firstDayOfWeek) {
  const weekDayDiff = firstDayOfMonth.weekday - firstDayOfWeek;
  return (weekDayDiff + 7) % 7;
}

export default function getNumberOfCalendarMonthWeeks(
  month,
  firstDayOfWeek = getFirstDayOfWeek(),
) {
  const firstDayOfMonth = cloneDateTime(month).startOf('month').set({ hours: 12 });
  const numBlankDays = getBlankDaysBeforeFirstDay(firstDayOfMonth, firstDayOfWeek);
  return Math.ceil((numBlankDays + month.daysInMonth) / 7);
}
